import "./styles/main.scss"  // wraps bulma